import React from "react"
import { graphql, Link, PageProps, HeadProps } from "gatsby"

import {
  Layout,
  PageTitle,
  ShareLink,
  Seo,
  BreadcrumbNav,
  BreadcrumbPath,
  Breadcrumb
} from "components"
import { ResourceList } from "components/resource"

export default function ResourceCollectionTemplate({
  data,
  location: { pathname }
}: PageProps<Queries.ResourceCollectionTemplateQuery>) {
  if (data.contentfulResourceCollection === null) {
    throw Error("Failed to load resource collection page.")
  }

  const { title, description, resources } = data.contentfulResourceCollection

  return (
    <Layout className="md:bg-[image:url(~images/wheel.svg)] md:bg-[position:-17.5rem_1.5rem] md:bg-no-repeat">
      <div className="container">
        <BreadcrumbNav>
          <BreadcrumbPath>
            <Breadcrumb>
              <Link to="/resources">Resources</Link>
            </Breadcrumb>

            <Breadcrumb>{title}</Breadcrumb>
          </BreadcrumbPath>
        </BreadcrumbNav>

        <div className="row">
          <div className="col-lg-10 col-xl-8 offset-lg-1 offset-xl-2">
            <PageTitle>{title}</PageTitle>

            {description && (
              <div className="mb-4 whitespace-pre-line text-xl">
                {description.description}
              </div>
            )}

            <ShareLink className="mb-8 justify-center" pathname={pathname}>
              Share these Resources on:
            </ShareLink>

            <ResourceList items={resources} />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const templateQuery = graphql`
  query ResourceCollectionTemplate($id: String!) {
    contentfulResourceCollection(contentful_id: { eq: $id }) {
      title
      description {
        description
      }
      resources {
        ...ResourceListItem
      }
    }
  }
`

export const Head = ({
  data
}: HeadProps<Queries.ResourceCollectionTemplateQuery>) => (
  <Seo title={data.contentfulResourceCollection?.title}>
    <script
      type="text/javascript"
      src="https://d1bxh8uas1mnw7.cloudfront.net/assets/embed.js"
    />
  </Seo>
)
